import { Button, Form, Image, Input, Typography } from "antd";
import { useDispatch } from "react-redux";
import { useLocation } from "wouter";
import { DealerForgotPwd } from "../../../redux/actions/authActions";
import Alertify from "../../../services/alertify";
const { Title } = Typography;
const ForgotPassword = () => {
  const dispatch = useDispatch();
  const [, setLocation] = useLocation();

  const handleSubmit = (values) => {
    const data = {
      email: values.email,
    };
    // console.log(data);

    dispatch(DealerForgotPwd(data))
      .then((response) => {
        // console.log(response);
        if (response.meta.requestStatus === "fulfilled") {
          setLocation("/login/dealer");
        }
      })
      .catch((error) => {
        console.log("The error is :", error);
        const errorMessage =
          error.response?.data?.error?.email?.[0] || "An error occurred";
        Alertify.error("Password reset: " + errorMessage);
      });
  };
  return (
    <div className="my-4 xl:my-16 place-items-center max-sm:p-4">
      <Form
        layout="vertical"
        className="shadow-2xl p-10 sm:w-1/3 rounded-lg w-full"
        size={"large"}
        onFinish={handleSubmit}
      >
        {/* <Image width={100} src="/assets/alp.svg" preview={false} /> */}
        <Title level={2}>Forgot Password</Title>
        <Form.Item label="Email Address" name="email">
          <Input type="email" placeholder="Enter Email" />
        </Form.Item>
        <Form.Item>
          <Button className="w-full" type="primary" htmlType="submit">
            SUBMIT
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default ForgotPassword;
